import React from "react";
import { Helmet } from "react-helmet-async";

function JsonLd({ data }) {
  const payload = Array.isArray(data) ? data : [data];

  return (
    <Helmet>
      {payload.map((item, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(item)}
        </script>
      ))}
    </Helmet>
  );
}

export default JsonLd;
